export function isTokenExpired (token) {
  const decodedToken = decodeJWT(token)
  return new Date(decodedToken.exp * 1000) < new Date()
}

function decodeJWT (token) {
  return JSON.parse(Buffer.from(token.split('.')[1], 'base64').toString())
}
